import * as types from './actionTypes';

export const accept = (id) => {
  return{
    type: types.INVITATION_ACCEPT_REQUEST,
    payLoad: id,
  }
};
export const acceptSuccess = (id) => {
  return {
    type: types.INVITATION_ACCEPT_SUCCESS,
    payLoad: id
  };
};
export const acceptFailure = (id) => {
  return {
    type: types.INVITATION_ACCEPT_FAILURE,
    payLoad: id
  };
};

export const reject = (id) => {
  return{
    type: types.INVITATION_REJECT_REQUEST,
    payLoad: id,
  }
};
export const rejectSuccess = (id) => {
  return {
    type: types.INVITATION_REJECT_SUCCESS,
    payLoad: id
  };
};
export const rejectFailure = (id) => {
  return {
    type: types.INVITATION_REJECT_FAILURE,
    payLoad: id
  };
};

export const checkPhoneNumber = (data) => {
  return{
    type: types.CHECK_PHONE_NUMBER_REQUEST,
    payLoad: data
  }
};
export const checkPhoneNumberSuccess = (data) => {
  return {
    type: types.CHECK_PHONE_NUMBER_SUCCESS,
    payLoad: data
  };
};
export const checkPhoneNumberFailure = (data) => {
  return {
    type: types.CHECK_PHONE_NUMBER_FAILURE,
    payLoad: data
  };
};

export const sendSms = (phoneNumber) => {
  return{
    type: types.SEND_SMS_REQUEST,
    payLoad: phoneNumber
  }
};
export const sendSmsSuccess = (data) => {
  return {
    type: types.SEND_SMS_SUCCESS,
    payLoad: data
  };
};
export const sendSmsFailure = (data) => {
  return {
    type: types.SEND_SMS_FAILURE,
    payLoad: data
  };
};

export const invite = (data) => {
  return{
    type: types.INVITE_REQUEST,
    payLoad: data
  }
};
export const inviteSuccess = (data) => {
  return {
    type: types.INVITE_SUCCESS,
    payLoad: data
  };
};
export const inviteFailure = (data) => {
  return {
    type: types.INVITE_FAILURE,
    payLoad: data
  };
};
export const mapsaInvite = (data) => {
  return {
    type: types.INVITATION_MAPSA_REQUEST,
    data
  };
};
export const mapsaInviteSuccess = (data) => {
  return {
    type: types.INVITATION_MAPSA_SUCCESS,
    data: data.data,
    phoneNumber: data.phoneNumber
  };
};
export const mapsaInviteFailure = () => {
  return {
    type: types.INVITATION_MAPSA_FAILURE
  };
};
